window.jQuery = require('jquery');
window.Prism = require('prismjs');
require('prismjs/themes/prism.css');
require('bootstrap');
require('bootstrap/dist/css/bootstrap.css');

//window.z = require('./ztools');

require('../css/icons.css');
require('../css/theme.css');
require('../css/page_numbers.css');

// Highlight all matching syntax
Prism.highlightAll();
